import React from 'react'
import { connect } from 'react-redux'
import { MultiSelect } from '@/components/MultiSelect'
import { Main, MainTop, MainTopLeft, MainTopTitle, MainBody, WhiteBox } from '@/components/Layout'
import { Row, Col, Button } from 'reactstrap'
import { BsrsGrid, Column, actionButtonsColumnProps, IN_EDIT, DateCell, DateFilterCell } from '@/components/BsrsGrid'
import Icon from '@/components/Icon'
import getEnumTranslation from '@/enums/enums'
import { VALUES as WeekDayValues } from '@/enums/WeekDays'
import uuid from 'uuid'
import { dialogTypes } from '@/dialogs'
import { openDialog } from '@/store/Dialogs'
import moment from 'moment'
import { withPermissions } from '@/decorators/withPermissions'

const weekDaysData = localize => WeekDayValues.map(x => ({ dayOfWeek: x, title: getEnumTranslation({ localize, enumName: 'WeekDay', value: x }) }))

@withPermissions()
class ReportingYearHolidaysForm extends React.Component {
  constructor (props, context) {
    super(props, context)
    this.state = {
      weekHolidays: (props.reportingYear.year.weekHolidays || []).map(w => ({
        dayOfWeek: w.dayOfWeek,
        title: getEnumTranslation({ localize: props.localize, enumName: 'WeekDay', value: w.dayOfWeek })
      })),
      officialHolidays: (props.reportingYear.year.officialHolidays || []).map(x => ({
        guid: uuid(),
        id: x.id,
        date: moment({ year: props.reportingYear.year.number, month: x.month - 1, day: x.day }),
        name: x.name,
        recurring: x.recurring
      }))
    }
  }

  onItemEdited (editedItem) {
    const newState = {
      ...this.state,
      officialHolidays: this.state.officialHolidays.map(oh => {
        if (oh.guid === editedItem.item.guid) {
          const item = { ...editedItem.item }
          // remove 'inEdit' property, otherwise the grid is confused and switching between edited columns doesn't work
          delete item[IN_EDIT]

          return item
        } else {
          return oh
        }
      })
    }
    this.setState(newState)
  }

  deleteItem (guid) {
    this.setState({
      officialHolidays: this.state.officialHolidays.filter(x => x.guid !== guid)
    })
  }

  save () {
    const input = {
      id: this.props.reportingYear.year.id,
      number: this.props.reportingYear.year.number,
      weekHolidays: this.state.weekHolidays,
      officialHolidays: this.state.officialHolidays.map(x => ({
        id: x.id,
        day: x.date.date(),
        month: x.date.month() + 1,
        name: x.name,
        recurring: x.recurring
      }))
    }
    this.props.updateHolidays(input)
  }
  canManage () { return this.props.isGranted('CanManageReportingCalendars') }

  addNewOfficialHoliday (newHoliday) {
    const newHolidays = [...this.state.officialHolidays, {
      guid: uuid(),
      id: 0,
      name: newHoliday.name,
      date: newHoliday.date,
      recurring: newHoliday.recurring
    }]
    this.setState({
      officialHolidays: newHolidays
    })
  }

  onChangeWeekDays = ({ value }) => {
    this.setState({ weekHolidays: value.map(x => ({ dayOfWeek: x })) })
  }

  render () {
    const { localize, reportingYear } = this.props
    const title = `${localize('Reporting.Holidays')} ${reportingYear.year.number}`
    const canManage = this.canManage()
    const buttons = []
    if (canManage) {
      buttons.push({ onDelete: item => this.deleteItem(item.guid), confirmText: 'Reporting.DeleteConfirmText' })
    }
    return (
      <Main>
        <MainTop>
          <MainTopTitle>{title}</MainTopTitle>
          <MainTopLeft>
            <Button disabled={!canManage} color='success' size='sm' onClick={() => this.save()}><Icon name='save' /> <span>{localize('Common.Save')}</span></Button>
          </MainTopLeft>
        </MainTop>
        <MainBody clear>
          <Row>
            <Col xl='5'>
              <WhiteBox header={localize('Reporting.WeekHolidays')}>
                <MultiSelect
                  disabled={!canManage}
                  data={weekDaysData(localize)}
                  textField='title'
                  valueField='dayOfWeek'
                  onChange={this.onChangeWeekDays}
                  value={this.state.weekHolidays.map(x => x.dayOfWeek)} />
              </WhiteBox>
            </Col>
            <Col xl='7'>
              <WhiteBox
                header={localize('Reporting.OfficialHolidays')}
                buttons={<Button disabled={!canManage} color='primary' onClick={() =>
                  this.props.openDialog({ dialogType: dialogTypes.newReportingHolidays, year: reportingYear.year, onAction: newHoliday => this.addNewOfficialHoliday(newHoliday) })
                }><Icon name='plus' />{localize('Reporting.AddNew')}
                </Button>}>
                <BsrsGrid items={this.state.officialHolidays}
                  exitEditingOnEnter
                  editable
                  onItemEdited={(editedItem) => this.onItemEdited(editedItem)}
                  simpleView>
                  <Column field='name' title={localize('Reporting.Holiday')} editor='text' editable className='editable' />
                  <Column field='date' title={localize('Reporting.Day')} cell={DateCell} filterCell={DateFilterCell} filter='date' editor='date' width='150px' editable />
                  <Column field='recurring' title={localize('Reporting.Recurring')} editor='boolean' width='100px' editable />
                  <Column {...actionButtonsColumnProps(buttons)} />
                </BsrsGrid>
              </WhiteBox>
            </Col>
          </Row>
        </MainBody>
      </Main>
    )
  }
}

const mapDispatchToProps = {
  openDialog
}

export default connect(null, mapDispatchToProps)(ReportingYearHolidaysForm)



// WEBPACK FOOTER //
// ./src/internal-app/components/years/ReportingYearHolidaysForm.js